import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParkingWizardStore } from 'Stores/ParkingWizardStore';
import NavigationWrapper from 'Views/Components/Navigation/NavigationWrapper';
import { Button, Colors, Display } from 'Views/Components/Button/Button';
import Icon from 'Views/Components/_HumanWritten/Icon/Icon';
import {
	getParkingReservationsByTransactionId,
	ParkingReservationSummaryDto,
} from 'Services/Api/_HumanWritten/ParkingService';
import { ParkingReservationSummaryCard } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/WizardSteps/Cart/ParkingReservationSummaryCard';

export default function ParkingSuccessPage() {
	const navigate = useNavigate();
	const { reservationId, transactionId, humanReadableId, totalPrice } = useParkingWizardStore();
	const [reservations, setReservations] = useState<ParkingReservationSummaryDto[]>([]);

	useEffect(() => {
		document.title = 'Parking Reservation Confirmed';
	}, []);

	useEffect(() => {
		if (transactionId) {
			getParkingReservationsByTransactionId(transactionId)
				.then(res => setReservations(res))
				.catch(() => setReservations([]));
		}
	}, [transactionId]);

	return (
		<div className="body-content">
			<NavigationWrapper />
			<div className="parking-success-page">
				<div className="parking-success-page__header">
					<Icon name="check_circle" classname="parking-success-page__icon" useMaterialIcons />
					<h2>Parking Reservation Confirmed</h2>
					<p>Your parking reservation has been successfully created.</p>
				</div>

				{reservations.length > 0 && (
					<div className="parking-success-page__summary">
						<div className="trip-booking-summary-card__container cart-view">
							<div className="bookings-list__scrollable">
								{reservations.map(reservation => (
									<ParkingReservationSummaryCard
										key={reservation.id}
										reservation={reservation}
										showReservationId
									/>
								))}
							</div>
						</div>
					</div>
				)}

				<div className="parking-success-page__actions">
					<Button display={Display.Solid} colors={Colors.Primary} onClick={() => navigate('/home')} newStyles>
						Return Home
					</Button>
					<Button
						display={Display.Outline}
						colors={Colors.Primary}
						onClick={() => navigate('/parking')}
						newStyles
					>
						Book More Parking
					</Button>
				</div>
			</div>
		</div>
	);
}
